<template slot-scope="scope">
  <div>
    <ods-dialog
  title="¿Estás seguro?"
  :visible.sync="isVisible"
  width="30%"
  :before-close="handleClose"
  :append-to-body="true">
  <span class="estas-a-punto-de-eli">Estás a punto de eliminar esta cuenta de forma permanente</span>
  <span slot="footer" class="dialog-footer">
    <ods-button type="text" @click="handleClose()">cancel</ods-button>
    <ods-button @click="deleteUser" type="danger">eliminar</ods-button>
  </span>
</ods-dialog>
<dialog-generic-error
        :message="errorMessage"
        :dialogError="dialogError"
        :before-close-fn="handleCloseSession"
        @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
      <dialog-generic-success
        :dialogSuccess="dialogSuccess"
        @dialogClosed="closeDialogSuccess($event)">
      </dialog-generic-success>
      <dialog-generic-warning
        :message="warningMessage"
        :dialogWarning="dialogWarning"
        @dialogClosed="closeDialogWarning($event)">
      </dialog-generic-warning>
  </div>
</template>

<script>
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
import DialogGenericWarning from '@/components/dialogs/DialogGenericWarning'
import { mapGetters } from 'vuex'
export default {
  props: ['isVisible', 'rowDelete', 'codcomercio'],
  data () {
    return {
      dialogVisible: false,
      dialogError: false,
      dialogSuccess: false,
      dialogWarning: false,
      errorMessage: '',
      warningMessage: ''
    }
  },
  ...mapGetters([
    'getDeleteUserData'
  ]),
  methods: {
    handleClose () {
      this.$emit('closingDialog', this.dialogVisible)
    },
    deleteUser () {
      this.$store.dispatch('deleteUser', this.rowDelete.usuario).then(r => {
        this.refreshListUsers()
        this.handleClose()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else if (r.warning === true) {
          this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
        } else {
          this.displayConfirmSuccess()
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    displayConfirmSuccess () {
      this.dialogSuccess = true
    },
    displayErrorWarning (msg) {
      this.warningMessage = `${msg}`
      this.dialogWarning = true
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    closeDialogSuccess (e) {
      this.dialogSuccess = e
    },
    closeDialogWarning (e) {
      this.dialogWarning = e
    },
    refreshListUsers () {
      this.$store.dispatch('listUsers', { codcom: this.codcomercio }).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    }
  },
  components: {
    DialogGenericError,
    'dialog-generic-success': DialogConfirmSuccess,
    'dialog-generic-warning': DialogGenericWarning
  }
}
</script>
<style lang="scss" scoped>

.estas-a-punto-de-eli {
  height: 72px;
  width: 360px;
  color: #6E767D;
  align: center;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 24px;
}

</style>
